import { isNull, isUndefined } from 'lodash'

export const isDefined = <T>(value: T | null | undefined): value is T => !isNull(value) && !isUndefined(value)
